/**
 * helper function to make requests to the WordPress REST API without the nonce
 * sending the nonce can cause issues with cached pages if the nonce goes stale
 * also handles JSON conversion and error handling for input/output
 *
 * @param path
 * @param options
 * @returns
 */
export const wpFetch = async (
  path: string,
  options?: Omit<RequestInit, "data"> & { data?: any },
) => {
  const { data, ...fetchOptions } = options || {};
  const response = await fetch(path, {
    ...fetchOptions,
    headers: {
      "Content-Type": "application/json",
      ...fetchOptions.headers,
    },
    body: data ? JSON.stringify(data) : undefined,
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // return null on empty response instead of trying to parse it as JSON, which would throw an error
  const text = await response.text();
  if (!text) {
    return null;
  }
  return JSON.parse(text);
};
